import React from 'react';
import { Play, ShieldCheck, Truck, Zap } from 'lucide-react';
import { FadeIn, StaggerContainer, StaggerItem } from './Animations';
export const VideoSection = () => {
  return <section className="py-20 md:py-24 bg-brand-black text-white relative overflow-hidden" data-id="element-544">
      {/* Background accents */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-red/10 rounded-full blur-3xl pointer-events-none" data-id="element-545" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-brand-red/5 rounded-full blur-3xl pointer-events-none" data-id="element-546" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-547">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-548">
          {/* Left: Video Player */}
          <FadeIn className="relative flex justify-center lg:justify-start" data-id="element-549">
            <div className="relative w-full max-w-[400px] rounded-sm overflow-hidden shadow-2xl border-4 border-zinc-800 bg-zinc-900" data-id="element-550">
              {/* Red accent behind video */}
              <div className="absolute -inset-4 bg-brand-red/20 blur-xl -z-10 rounded-full" data-id="element-551"></div>

              <video className="w-full h-auto aspect-[9/16] object-cover" autoPlay loop muted playsInline controls poster="https://cdn.magicpatterns.com/uploads/9xtkJAr7hK44a2vw9qRwjt/JEZ1.png" data-id="element-552">
                <source src="https://cdn.magicpatterns.com/uploads/66FDS99N3MZLdZ2zMSGKm7/9c75340e-c0d4-447b-ad91-1e4547812f90.MP4" type="video/mp4" data-id="element-553" />
                Your browser does not support the video tag.
              </video>

              {/* Floating badge */}
              <div className="absolute top-4 right-4 bg-brand-red text-white px-3 py-1.5 rounded-sm flex items-center gap-2 shadow-lg backdrop-blur-sm" data-id="element-554">
                <span className="w-2 h-2 bg-white rounded-full animate-pulse" data-id="element-555" />
                <span className="font-oswald font-bold uppercase text-xs tracking-wider" data-id="element-556">
                  Heavy Duty
                </span>
              </div>
            </div>
          </FadeIn>

          {/* Right: Copy */}
          <div data-id="element-557">
            <FadeIn data-id="element-558">
              <div className="text-xs font-bold uppercase tracking-[0.2em] text-brand-red mb-4" data-id="element-559">
                Our Equipment
              </div>
              <h2 className="font-oswald text-4xl md:text-5xl lg:text-6xl font-bold uppercase leading-[0.95] mb-6" data-id="element-560">
                Built for the <br data-id="element-561" />
                <span className="text-brand-red" data-id="element-562">Toughest Jobs.</span>
              </h2>
              <p className="text-lg text-zinc-300 mb-8 leading-relaxed" data-id="element-563">
                We don't show up in a pickup truck. Our heavy-duty dump trailers
                are designed to handle massive volumes of junk, construction
                debris, and heavy materials in a single trip.
              </p>
            </FadeIn>

            <StaggerContainer className="space-y-6 mb-10" data-id="element-564">
              {[{
              icon: Truck,
              title: 'High-Capacity Trailers',
              desc: 'Fewer trips means we get the job done faster and cheaper.'
            }, {
              icon: Zap,
              title: 'Commercial Grade',
              desc: 'Built to haul concrete, dirt, appliances, and heavy furniture.'
            }, {
              icon: ShieldCheck,
              title: 'Safe & Professional',
              desc: 'We operate safely on your property without damaging driveways.'
            }].map((item, i) => <StaggerItem key={i} className="flex items-start gap-4" data-id="element-565">
                  <div className="w-12 h-12 bg-brand-red/10 border border-brand-red/20 flex items-center justify-center rounded-sm shrink-0" data-id="element-566">
                    <item.icon className="w-6 h-6 text-brand-red" data-id="element-567" />
                  </div>
                  <div data-id="element-568">
                    <h3 className="font-oswald text-xl font-bold uppercase tracking-wide mb-1" data-id="element-569">
                      {item.title}
                    </h3>
                    <p className="text-sm text-zinc-400" data-id="element-570">{item.desc}</p>
                  </div>
                </StaggerItem>)}
            </StaggerContainer>

            <FadeIn delay={0.3} data-id="element-571">
              <a href="tel:+15597709442" className="inline-flex items-center justify-center gap-2 bg-brand-red hover:bg-brand-darkred text-white px-8 py-4 rounded-sm font-oswald font-bold text-lg transition-colors uppercase tracking-wide" data-id="element-572">
                <Play className="w-5 h-5 fill-current" data-id="element-573" />
                See Us In Action — Call Now
              </a>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
};